import React, { Fragment, useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
const NumberTotalConversation = ({
  history,
  numbertimedata,
  messengerAvatar,
  fromDate,
  toDate,
  isVoice = false,
}) => {
  const getLabel = (lab) => {
    switch (lab.toLowerCase()) {
      case 'webchattime':
        return 'dashboards.number-webchattime';
      case 'totalconversation':
        return 'dashboards.number-totalconversation';
    }
    return lab;
  };
  const getLabelIcon = (lab) => {
    switch (lab.toLowerCase()) {
      case 'webchattime':
        return 'iconsminds-clock';
      case 'totalconversation':
        return 'iconsminds-speach-bubbles';
      case 'avatarclick':
        return 'iconsminds-finger-print';
      case 'voice':
        return 'iconsminds-phone-3';
    }
    return lab;
  };
  const CalculateHours = (value) => {
    var hours = value / 60;
    return Math.ceil(hours);
  };
  const calculateDay = (startDate, endDate) => {
    var start = moment(startDate).format('YYYY-MM-DD');
    var end = moment(endDate).format('YYYY-MM-DD');
    var date1 = new Date(start);
    var date2 = new Date(end);
    var time_difference = date2.getTime() - date1.getTime();
    return time_difference / (1000 * 60 * 60 * 24);
  };
  const CalculateAverageTimePerConversation = (numbertimedata) => {
    if (isVoice) {
      var totalConversation = 0;
      var totalChatTime = 0;
      numbertimedata.map((x) => {
        if (x.type === 'voiceConversations') {
          totalConversation = x.average;
        }
      });
      return totalConversation;
    } else {
      var totalConversation = 0;
      var totalChatTime = 0;
      numbertimedata.map((x) => {
        if (x.type === 'totalConversation') {
          totalConversation = x.value;
        }
        if (x.type === 'webchattime') {
          totalChatTime = x.value;
        }
      });
      var cal = 0;
      if (totalChatTime !== '0' && totalConversation !== '0') {
        cal = Math.round(
          parseFloat(totalChatTime) / parseFloat(totalConversation)
        );
      }
      return cal;
    }
  };
  const handleArchiveURL = (value, type) => {
    let days = calculateDay(fromDate, toDate);
    if (type === 'All') {
      history.push({
        pathname: '/app/pages/agent-assist',
        state: { tagName: type, date: days },
      });
    }
  };
  const AvatarClickDiv = (data) => {
    return (
      <Fragment>
        <div className="col-sm-4 col-lg-3 col-xl-3">
          <div className="card">
            <div className="text-center card-body">
              <i
                className={getLabelIcon(isVoice ? 'voice' : 'avatarclick')}
              ></i>
              <p className="card-text font-weight-semibold mb-0">
                {isVoice ? (
                  'Total Calls'
                ) : (
                  <IntlMessages id="dashboards.number-totalavatarclick" />
                )}
              </p>
              <p className="lead text-center" style={{ fontSize: '1.2rem' }}>
                {data}{' '}
                {isVoice ? 'Calls' : <IntlMessages id="dashboards.clicks" />}
              </p>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  return (
    <Fragment>
      <div className="iconcards-row row d-flex">
        {messengerAvatar !== undefined &&
          messengerAvatar !== null &&
          AvatarClickDiv(messengerAvatar)}

        {numbertimedata !== undefined && numbertimedata.length > 0 && (
          <Fragment>
            {isVoice ? (
              <Fragment>
                {numbertimedata.filter((x) => x.type === 'voiceConversations')
                  .length > 0 && (
                  <div
                    className="col-sm-4 col-lg-3 col-xl-3"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleArchiveURL('', 'All')}
                  >
                    <div className="card">
                      <div className="text-center card-body">
                        <i className={getLabelIcon('totalconversation')}></i>
                        <p className="card-text font-weight-semibold mb-0">
                          <IntlMessages id={getLabel('totalconversation')} />
                        </p>
                        <p
                          className="lead text-center"
                          style={{ fontSize: '1.2rem' }}
                        >
                          {
                            numbertimedata.filter(
                              (x) => x.type === 'voiceConversations'
                            )[0].conversations
                          }{' '}
                          <IntlMessages id="pages.title.conversations" />
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {numbertimedata.filter((x) => x.type === 'voiceConversations')
                  .length > 0 && (
                  <div className="col-sm-4 col-lg-3 col-xl-3">
                    <div className="card">
                      <div className="text-center card-body">
                        <i className={getLabelIcon('webchattime')}></i>
                        <p className="card-text font-weight-semibold mb-0">
                          <IntlMessages id={getLabel('webchattime')} />
                        </p>
                        {/* <p
                            className="lead text-center"
                            style={{ fontSize: '1.2rem' }}
                          >
                            {numbertimedata.filter(
                              (x) => x.type === 'voiceConversations'
                            )[0].value > 180
                              ? CalculateHours(
                                parseInt(
                                  numbertimedata.filter(
                                    (x) => x.type === 'voiceConversations'
                                  )[0].value
                                )
                              ) + ' Hours'
                              : numbertimedata.filter(
                                (x) => x.type === 'voiceConversations'
                              )[0].value + <IntlMessages id='dashboards.minutes' />}
                          </p> */}

                        <p
                          className="lead text-center"
                          style={{ fontSize: '1.2rem' }}
                        >
                          {(() => {
                            const voiceData = numbertimedata.filter(
                              (x) => x.type === 'voiceConversations'
                            )[0];
                            if (!voiceData) return null;

                            const value = parseInt(voiceData.value);
                            return (
                              <>
                                {value} <IntlMessages id="dashboards.minutes" />
                              </>
                            );
                          })()}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </Fragment>
            ) : (
              <Fragment>
                {numbertimedata
                  .filter((x) => x.type === 'totalConversation')
                  .map((per, index) => (
                    <div
                      className="col-sm-4 col-lg-3 col-xl-3"
                      style={{ cursor: 'pointer' }}
                      key={index}
                      onClick={() => handleArchiveURL('', 'All')}
                    >
                      <div className="card">
                        <div className="text-center card-body">
                          <i className={getLabelIcon(per.type)}></i>
                          <p className="card-text font-weight-semibold mb-0">
                            <IntlMessages id={getLabel(per.type)} />
                          </p>
                          <p
                            className="lead text-center"
                            style={{ fontSize: '1.2rem' }}
                          >
                            {per.value}{' '}
                            <IntlMessages id="pages.title.conversations" />
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                {numbertimedata
                  .filter((x) => x.type === 'webchattime')
                  .map((per, index) => (
                    <Fragment>
                      <div className="col-sm-4 col-lg-3 col-xl-3" key={index}>
                        <div className="card">
                          <div className="text-center card-body">
                            <i className={getLabelIcon(per.type)}></i>
                            <p className="card-text font-weight-semibold mb-0">
                              <IntlMessages id={getLabel(per.type)} />
                            </p>
                            <p
                              className="lead text-center"
                              style={{ fontSize: '1.2rem' }}
                            >
                              {per.value > 180 ? (
                                <>
                                  {CalculateHours(parseInt(per.value))}{' '}
                                  <IntlMessages id="dashboards.hours" />
                                </>
                              ) : (
                                <>
                                  {per.value}{' '}
                                  <IntlMessages id="dashboards.minutes" />
                                </>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  ))}
              </Fragment>
            )}
          </Fragment>
        )}

        <div className="col-sm-4 col-lg-3 col-xl-3">
          <div className="card">
            <div className="text-center card-body">
              <i className={'iconsminds-clock'}></i>
              <p className="card-text font-weight-semibold mb-0">
                <IntlMessages
                  id={'dashboards.number-averagetimeconversation'}
                />
              </p>
              {isVoice ? (
                <p className="lead text-center" style={{ fontSize: '1.2rem' }}>
                  {numbertimedata.filter((x) => x.type === 'voiceConversations')
                    .length > 0
                    ? numbertimedata.filter(
                        (x) => x.type === 'voiceConversations'
                      )[0].average
                    : 0}{' '}
                  <IntlMessages id="dashboards.minutes" />
                </p>
              ) : (
                <p className="lead text-center" style={{ fontSize: '1.2rem' }}>
                  {CalculateAverageTimePerConversation(numbertimedata)}{' '}
                  <IntlMessages id="dashboards.minutes" />
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default NumberTotalConversation;
